import { render } from "./SecondaryArticleSpots.vue?vue&type=template&id=e6eda844"
import script from "./SecondaryArticleSpots.vue?vue&type=script&lang=js"
export * from "./SecondaryArticleSpots.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__